"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const array_to_query_string_1 = __importDefault(require("./array_to_query_string"));
function appendParamsToUrl(url, params) {
  const paramsString = typeof params === 'string' ? params : array_to_query_string_1.default(params);
  if (url.includes('?')) {
    return [url, paramsString].join('&');
  } else {
    return [url, paramsString].join('?');
  }
}
exports.default = appendParamsToUrl;